import script from "./coinListPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./coinListPopup.vue?vue&type=script&setup=true&lang=js"

import "./coinListPopup.vue?vue&type=style&index=0&id=34739430&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34739430"]])

export default __exports__